import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink, Center,
  Heading,
  SimpleGrid, Text,
  VStack,
} from '@chakra-ui/react';
import ProductCard from './ProductCard';
import {useState} from 'react';
import ProductDetail from './ProductDetail';

const OnlineStore = ({products}) => {
  const [breadCrumb, setBreadCrumb] = useState([{
    name: 'All',
    id: null,
  }]);
  const [curProduct, setCurProduct] = useState(null);
  const handleProductClick = (product) => {
    setBreadCrumb([...breadCrumb, {
      name: product.productName,
      id: product.productId,
    }]);
    setCurProduct(product);
  };

  const handleBreadCrumbClick = (id) => {
    if (id === null) {
      setBreadCrumb([{
        name: 'All',
        id: null,
      }]);
      setCurProduct(null);
    }
  };

  const productList = (
    <SimpleGrid
      minChildWidth={'320px'}
      spacing={10}>
      {products.map((product) => (
        <Box
          maxW={'320px'}
          width={'100%'}
          margin={'auto'}
          key={product.productId}>
          <ProductCard
            clickHandler={handleProductClick}
            product={product}/>
        </Box>
      ))}
    </SimpleGrid>
  );

  const productDetail = (
    <ProductDetail
      product={curProduct}/>
  );


  return (
    <Box>
      <Box
        padding={3}
        bgColor={'#FCDEC0'}>
        <Center>
          <Text
            color={'#483434'}
            fontSize={17}>Free Shipping on All Orders Over $20!</Text>
        </Center>
      </Box>
      <VStack
        alignItems={'start'}
        padding={6}>
        <Breadcrumb>
          {breadCrumb.map((item, i) => (
            <BreadcrumbItem
              onClick={handleBreadCrumbClick.bind(null, item.id)}
              isCurrentPage={i === breadCrumb.length - 1}
              key={`breadcrumb-${i}`}>
              <BreadcrumbLink>
                <Heading
                  size={'md'}
                  fontWeight={i === breadCrumb.length - 1 ? 'bold' : 'normal'}>
                  {item.name}
                </Heading>
              </BreadcrumbLink>
            </BreadcrumbItem>))}
        </Breadcrumb>
        <Box
          width={'100%'}>
          {curProduct === null ? productList : productDetail}
        </Box>
      </VStack>
    </Box>
  );
};

export default OnlineStore;
